var service = {};

if (process.env.NODE_ENV === 'production') {
    service.API_URL = process.env.REACT_APP_API_URL;
} else {
    service.API_URL = 'http://192.168.1.105:5001';
}

export default service;
